"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReauthenticationEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class ReauthenticationEvent extends web_ui_framework_1.Event {
}
exports.ReauthenticationEvent = ReauthenticationEvent;
//# sourceMappingURL=reauthenticationEvent.js.map